/**
 *
 * Created by jlado on 19/8/16.
 */
export class LookAndFeelBank {
    font:string;
    fontColor:string;
    backgroundColor:string;

    constructor(other:LookAndFeelBank) {
        if (other) {
            this.font = other.font;
            this.fontColor = other.fontColor;
            this.backgroundColor = other.backgroundColor;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/lookAndFeelBank.ts
 **/